import { render, staticRenderFns } from "./BtnEdit.vue?vue&type=template&id=21c6e55e&scoped=true"
import script from "./BtnEdit.vue?vue&type=script&lang=js"
export * from "./BtnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6e55e",
  null
  
)

export default component.exports